import React from 'react';
import { Switch } from 'react-router-dom';
import { __RouterContext as RouterContext } from 'react-router';
import invariant from 'invariant';
import matchPath from '@src/layout-components/route/route-switch-enhance/match-path';

export default class RouteSwitchEnhance extends Switch {
  render() {
    return (
      <RouterContext.Consumer>
        {context => {
          invariant(context, 'You should not use <Switch> outside a <Router>');
          const location = this.props.location || context.location;
          let element, match;
          React.Children.forEach(
            this.props.children,
            child => {
              if (match == null && React.isValidElement(child)) {
                element = child;
                const path = child.props.path || child.props.from;
                match = path ? matchPath({ pathname: location.pathname, query: location.search }, { ...child.props, path }) : context.match;
              }
            },
            undefined
          );
          return match ? React.cloneElement(element, { location, computedMatch: match }) : null;
        }}
      </RouterContext.Consumer>
    );
  }
}

Object.assign(RouteSwitchEnhance, Switch);
